module.exports = __webpack_public_path__ + "img/banner3.bb355e88.png";